import { c as _c } from "react/compiler-runtime";
import { SimpleDetails, type SimpleDetailsProps } from './components/SimpleDetails';
import { CustomizedSummaryDetails, type CustomizedSummaryDetailsProps } from './components/CustomizedSummaryDetails';
type Props = SimpleDetailsProps | CustomizedSummaryDetailsProps;
export function Details(props) {
  const $ = _c(4);
  if (props.variant === "simple") {
    let t0;
    if ($[0] !== props) {
      t0 = <SimpleDetails {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <CustomizedSummaryDetails {...props} />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}
export type { SimpleDetailsProps, CustomizedSummaryDetailsProps };